
























import { defineComponent, ref, provide  } from "@nuxtjs/composition-api";
import { useGtm } from "~/composables";
import MenuItemSub from "./MenuItemSub.vue";

export default defineComponent({
  name: "MenuItem",
  components: {
    MenuItemSub,
  },
  props: {
    menu: {
      type: Object,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
  },
  setup() {
    const { eventCustomlinksInteracted } = useGtm();
    const onMouseEnter = () => (isOpen.value = true);
    const onMouseLeave = () => (isOpen.value = false);
    const isOpen = ref(false);
    const closeNav = (value) => {
      isOpen.value = value;
    };
    provide('isOpen', {isOpen, closeNav});
    const navigationTracking = (menu) => {
      eventCustomlinksInteracted({
        "eventlabel": menu.title,
        "eventCategory": "Primary Navigation Links",
      });
    };

    return {
      isOpen,
      onMouseEnter,
      onMouseLeave,
      closeNav,
      navigationTracking,
    };
  },
});
